<template>
    <div class="class1">
        Move the map around to place your marker where you want and click Next to place it.
    </div>
</template>

<style scoped>
.class1 {
    position: absolute;
    top: 0%;
    width: 100%;
    height: 50px;
    background: #000;
    opacity: 0.7;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
export default {
    data() {
        return {
            "a": "sss"
        }
    },
    methods: {
        mounted() {
            console.log('mounted from topbanner')
        }
    }
}
</script>